import React from 'react'
import {useNavigate} from 'react-router-dom'
import {ModeleReseauClient, modeleReseauClientInitValues} from '../../../components/Models'
import {createReseauClient} from '../../../components/requests'
import {ReseauClientForm} from './components/ReseauClientForm'
import Swal from 'sweetalert2'

const ReseauClientAddPage = () => {
  const navigate = useNavigate()
  const submitForm = async (
    fieldsToUpdate: Partial<ModeleReseauClient>,
    callback
  ): Promise<void> => {
    const updatedData = Object.assign({...modeleReseauClientInitValues}, fieldsToUpdate)
    var requestOk = false
    try {
      const reseauClientRequest = await createReseauClient(updatedData)
      if (reseauClientRequest?.status === 200) {
        if (reseauClientRequest?.data?.id !== undefined && reseauClientRequest?.data?.id !== null) {
          requestOk = true
          navigate(`/reseau-client`)
        }
      }
    } catch (ex:any) {
      if (ex.response?.status === 400) {
        const errorMessage = ex.response?.data?.message || "Ce Réseau Client existe déjà."
        Swal.fire({
          title: 'Oups',
          text: errorMessage,
          icon: 'warning',
          confirmButtonText: 'OK',
          confirmButtonColor: '#1BC5BD',
        })
      } else {
        console.error(ex)
      }
    } finally {
      callback()
    }
  }

  return (
    <>
      <div className='card mb-5 mb-xl-10'>
        <div className='card-header border-0 d-flex justify-content-between align-items-center'>
          <div className='card-title m-0'>
            <h3 className='fw-bolder m-0'>Créer un réseau client</h3>
          </div>
          {/*<Link
          to={`/reseau-client/liste`}
          state={{}}
          data-tooltip-id='tooltip'
          data-tooltip-content='Revenir en arrière'
          data-tooltip-place='right'
        >
          <img src='/media/svg/custom/prev-arrow.svg' width={40} />
        </Link>*/}
        </div>
        <div>
          <ReseauClientForm
            reseauClientId={null}
            data={modeleReseauClientInitValues}
            submitForm={submitForm}
          />
        </div>
      </div>
    </>
  )
}

export {ReseauClientAddPage}
